// auth 2.0
import React from "react";
import styled from "styled-components";
import Icon from "./Icon";
import { SvgIconProps } from "./types";

const SvgWrapper = styled(Icon)``;

export const NextVideoIcon = ({ width, height, color }: SvgIconProps) => {
  return (
    <SvgWrapper viewBox={`0 0 ${width} ${height}`} style={{ width, height }} fill="none">
      <path d="M0.5 12V0L8.5 6L0.5 12Z" fill={color ? `${color}` : `#F1F3F5`} />
      <path d="M9.5 0H11.5V12H9.5V0Z" fill={color ? `${color}` : `#F1F3F5`} />
    </SvgWrapper>
  );
};
